export function initAskFliptBridge() {
    if (customElements.get('askflipt-flashcard')) return;

    // Inject styles
    const style = document.createElement('style');
    style.textContent = `
        askflipt-flashcard {
            display: block;
            margin: 16px 0;
            width: 100%;
            min-width: 320px;
            max-width: 450px;
            perspective: 1000px;
            cursor: pointer;
            font-family: 'Inter', sans-serif;
        }
        .askflipt-fc-inner {
            position: relative;
            width: 100%;
            min-height: 220px;
            text-align: center;
            transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);
            transform-style: preserve-3d;
            border-radius: 16px;
            box-shadow: 0 10px 30px rgba(0,0,0,0.3);
        }
        askflipt-flashcard.flipped .askflipt-fc-inner {
            transform: rotateY(180deg);
        }
        .askflipt-fc-front, .askflipt-fc-back {
            position: absolute;
            top: 0; left: 0;
            width: 100%; height: 100%;
            -webkit-backface-visibility: hidden;
            backface-visibility: hidden;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 32px 24px;
            box-sizing: border-box;
            border-radius: 16px;
            font-size: 16px;
            line-height: 1.6;
            word-wrap: break-word;
            overflow-y: auto;
        }
        /* Custom scrollbar for cards */
        .askflipt-fc-front::-webkit-scrollbar, .askflipt-fc-back::-webkit-scrollbar { width: 4px; }
        .askflipt-fc-front::-webkit-scrollbar-thumb, .askflipt-fc-back::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.2); border-radius: 2px; }
        
        .askflipt-fc-front {
            background: linear-gradient(135deg, #f97316 0%, #ea580c 100%);
            color: #ffffff;
            font-weight: 500;
            border: 1px solid rgba(255,255,255,0.1);
        }
        .askflipt-fc-back {
            background: linear-gradient(135deg, #1e1e1e 0%, #2a2a2a 100%);
            color: #f2f2f0;
            transform: rotateY(180deg);
            border: 1px solid #444;
        }
        .askflipt-fc-badge {
            position: absolute;
            top: 16px; left: 20px;
            font-size: 11px;
            font-weight: 700;
            text-transform: uppercase;
            letter-spacing: 1.5px;
            opacity: 0.7;
        }
        .askflipt-fc-icon {
            position: absolute;
            bottom: 16px; right: 20px;
            font-size: 16px;
            opacity: 0.5;
        }

        askflipt-quiz {
            display: block;
            margin: 16px 0;
            padding: 24px;
            background: linear-gradient(145deg, #1a1a1a, #222);
            border: 1px solid #333;
            border-radius: 16px;
            font-family: 'Inter', sans-serif;
            color: #f2f2f0;
            min-width: 320px;
            max-width: 450px;
            box-shadow: 0 8px 24px rgba(0,0,0,0.2);
        }
        .askflipt-quiz-header {
            display: flex;
            align-items: center;
            gap: 8px;
            margin-bottom: 16px;
            font-size: 11px;
            font-weight: 700;
            text-transform: uppercase;
            letter-spacing: 1.5px;
            color: #a0a0a0;
        }
        .askflipt-quiz-q {
            font-weight: 600;
            margin-bottom: 20px;
            font-size: 16px;
            line-height: 1.5;
        }
        .askflipt-quiz-opt {
            padding: 14px 16px;
            margin-bottom: 10px;
            background: #2a2a2a;
            border: 1px solid #444;
            border-radius: 10px;
            cursor: pointer;
            transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
            display: flex;
            align-items: center;
            font-size: 14px;
            font-weight: 500;
        }
        .askflipt-quiz-opt:hover {
            background: #333;
            transform: translateY(-1px);
            border-color: #555;
        }
        .askflipt-quiz-opt.correct {
            background: rgba(34, 197, 94, 0.15);
            border-color: #22c55e;
            color: #4ade80;
        }
        .askflipt-quiz-opt.incorrect {
            background: rgba(239, 68, 68, 0.15);
            border-color: #ef4444;
            color: #f87171;
        }
        .askflipt-quiz-fb {
            margin-top: 16px;
            font-size: 14px;
            display: none;
            padding: 12px 16px;
            border-radius: 8px;
            font-weight: 500;
            animation: fadeIn 0.3s ease;
        }
        @keyframes fadeIn {
            from { opacity: 0; transform: translateY(-5px); }
            to { opacity: 1; transform: translateY(0); }
        }
        .askflipt-quiz-fb.show {
            display: block;
        }
        .askflipt-quiz-fb.correct-msg {
            background: rgba(34, 197, 94, 0.1);
            color: #4ade80;
            border: 1px solid rgba(34, 197, 94, 0.2);
        }
        .askflipt-quiz-fb.incorrect-msg {
            background: rgba(239, 68, 68, 0.1);
            color: #f87171;
            border: 1px solid rgba(239, 68, 68, 0.2);
        }

        askflipt-deck {
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 100%;
            margin: 24px 0;
            position: relative;
        }
        .askflipt-deck-controls {
            display: flex;
            align-items: center;
            gap: 16px;
            margin-top: 16px;
            background: rgba(43, 45, 49, 0.8);
            padding: 8px 16px;
            border-radius: 24px;
            border: 1px solid rgba(255, 255, 255, 0.1);
            backdrop-filter: blur(10px);
        }
        .askflipt-deck-btn {
            background: transparent;
            border: none;
            color: #b5bac1;
            cursor: pointer;
            font-size: 16px;
            width: 32px;
            height: 32px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: all 0.2s;
            outline: none;
        }
        .askflipt-deck-btn:hover:not(:disabled) {
            background: #404249;
            color: #f2f3f5;
        }
        .askflipt-deck-btn:disabled {
            opacity: 0.3;
            cursor: not-allowed;
        }
        .askflipt-deck-counter {
            font-size: 13px;
            font-family: 'Inter', sans-serif;
            color: #dbdee1;
            font-weight: 600;
            min-width: 40px;
            text-align: center;
        }
    `;
    document.head.appendChild(style);

    class AskFliptDeck extends HTMLElement {
        private currentIndex = 0;
        private cards: HTMLElement[] = [];
        private counterEl: HTMLElement | null = null;
        private prevBtn: HTMLButtonElement | null = null;
        private nextBtn: HTMLButtonElement | null = null;
        private quizBtn: HTMLButtonElement | null = null;
        private quizActive: boolean = false;
        private tempUserMsg: HTMLElement | null = null;

        connectedCallback() {
            // Use setTimeout to wait for child nodes to be fully parsed
            setTimeout(() => this.initDeck(), 50);
        }

        initDeck() {
            // Find all flashcards inside this deck (including inside P tags if marked.js wrapped them)
            this.cards = Array.from(this.querySelectorAll('askflipt-flashcard')) as HTMLElement[];
            if (this.cards.length === 0) return;

            // Hide all except first
            this.cards.forEach((card, index) => {
                if (index !== 0) {
                    card.style.display = 'none';
                }
            });

            // Create controls
            const controls = document.createElement('div');
            controls.className = 'askflipt-deck-controls';
            
            this.prevBtn = document.createElement('button');
            this.prevBtn.className = 'askflipt-deck-btn';
            this.prevBtn.innerHTML = '<i class="fas fa-chevron-left"></i>';
            this.prevBtn.onclick = () => this.navigate(-1);

            this.counterEl = document.createElement('div');
            this.counterEl.className = 'askflipt-deck-counter';
            this.counterEl.textContent = `1 / ${this.cards.length}`;

            this.nextBtn = document.createElement('button');
            this.nextBtn.className = 'askflipt-deck-btn';
            this.nextBtn.innerHTML = '<i class="fas fa-chevron-right"></i>';
            this.nextBtn.onclick = () => this.navigate(1);

            this.quizBtn = document.createElement('button');
            this.quizBtn.className = 'askflipt-deck-btn askflipt-deck-quiz-btn';
            this.quizBtn.innerHTML = '<i class="fas fa-play"></i>';
            this.quizBtn.title = 'Start Quiz Mode';
            this.quizBtn.onclick = () => this.toggleQuizMode();

            controls.appendChild(this.prevBtn);
            controls.appendChild(this.counterEl);
            controls.appendChild(this.nextBtn);
            controls.appendChild(this.quizBtn);
            
            this.appendChild(controls);
            this.updateControls();
        }

        toggleQuizMode() {
            this.quizActive = !this.quizActive;
            if (this.quizActive) {
                (window as any).__activeAskFliptQuiz = this;
                this.quizBtn!.style.color = '#4ade80';
                this.quizBtn!.innerHTML = '<i class="fas fa-stop"></i>';
                const input = document.getElementById('chatInput') as HTMLTextAreaElement;
                if (input) {
                    input.placeholder = 'Quiz Mode Active: Type your answer here...';
                    input.focus();
                }
            } else {
                (window as any).__activeAskFliptQuiz = null;
                this.quizBtn!.style.color = '';
                this.quizBtn!.innerHTML = '<i class="fas fa-play"></i>';
                const input = document.getElementById('chatInput') as HTMLTextAreaElement;
                if (input) {
                    input.placeholder = 'Ask anything...';
                }
                if (this.tempUserMsg) {
                    this.tempUserMsg.remove();
                    this.tempUserMsg = null;
                }
            }
        }

        getCurrentCardData() {
            const card = this.cards[this.currentIndex];
            if (!card) return null;
            return {
                q: card.getAttribute('q') || '',
                a: card.getAttribute('a') || ''
            };
        }

        async handleQuizResult(isCorrect: boolean, feedback: string, userMsgEl?: HTMLElement) {
            const card = this.cards[this.currentIndex];
            if (!card) return;

            if (userMsgEl) {
                this.tempUserMsg = userMsgEl;
            }

            // Show feedback
            const fbEl = document.createElement('div');
            fbEl.className = 'askflipt-quiz-fb show ' + (isCorrect ? 'correct-msg' : 'incorrect-msg');
            fbEl.textContent = isCorrect ? '✅ Correct! ' + feedback : '❌ Incorrect. ' + feedback;
            fbEl.style.marginTop = '12px';
            fbEl.style.width = '100%';
            fbEl.style.textAlign = 'center';
            fbEl.style.borderRadius = '12px';
            fbEl.style.padding = '8px';
            fbEl.style.fontFamily = "'Inter', sans-serif";
            fbEl.style.fontSize = '13px';
            
            card.appendChild(fbEl);
            
            // Flip to show answer
            if (!card.classList.contains('flipped')) {
                card.classList.add('flipped');
            }

            // Wait then move to next
            setTimeout(() => {
                fbEl.remove();
                if (this.currentIndex < this.cards.length - 1) {
                    this.navigate(1);
                } else {
                    this.toggleQuizMode(); // End quiz
                }
            }, 3000);
        }

        navigate(direction: number) {
            // Clear temporary user message from the UI when advancing
            if (this.tempUserMsg) {
                this.tempUserMsg.remove();
                this.tempUserMsg = null;
            }

            const newIndex = this.currentIndex + direction;
            if (newIndex >= 0 && newIndex < this.cards.length) {
                this.cards[this.currentIndex].style.display = 'none';
                this.currentIndex = newIndex;
                this.cards[this.currentIndex].style.display = 'block';
                this.cards[this.currentIndex].classList.remove('flipped');
                this.updateControls();
            }
        }

        updateControls() {
            if (this.prevBtn) this.prevBtn.disabled = this.currentIndex === 0;
            if (this.nextBtn) this.nextBtn.disabled = this.currentIndex === this.cards.length - 1;
            if (this.counterEl) this.counterEl.textContent = `${this.currentIndex + 1} / ${this.cards.length}`;
        }
    }

    class AskFliptFlashcard extends HTMLElement {
        connectedCallback() {
            const q = this.getAttribute('q') || '';
            const a = this.getAttribute('a') || '';
            
            this.innerHTML = `
                <div class="askflipt-fc-inner">
                    <div class="askflipt-fc-front">
                        <span class="askflipt-fc-badge"><i class="fas fa-layer-group"></i> AskFlipt</span>
                        ${q}
                        <i class="fas fa-hand-pointer askflipt-fc-icon"></i>
                    </div>
                    <div class="askflipt-fc-back">
                        <span class="askflipt-fc-badge" style="color:#f97316;"><i class="fas fa-check"></i> Answer</span>
                        ${a}
                        <i class="fas fa-undo askflipt-fc-icon"></i>
                    </div>
                </div>
            `;

            this.addEventListener('click', () => {
                this.classList.toggle('flipped');
            });
        }
    }

    class AskFliptQuiz extends HTMLElement {
        connectedCallback() {
            const q = this.getAttribute('q') || '';
            const correctStr = this.getAttribute('correct') || '0';
            const fbCorrect = this.getAttribute('feedback-correct') || 'Correct!';
            const fbIncorrect = this.getAttribute('feedback-incorrect') || 'Incorrect.';
            
            let options = [];
            try {
                options = JSON.parse(this.getAttribute('options') || '[]');
            } catch (e) {
                options = ['Option A', 'Option B'];
            }

            const correctIdx = parseInt(correctStr, 10);

            let optsHtml = '';
            options.forEach((opt: string, idx: number) => {
                optsHtml += `<div class="askflipt-quiz-opt" data-idx="${idx}">${opt}</div>`;
            });

            this.innerHTML = `
                <div class="askflipt-quiz-header">
                    <i class="fas fa-clipboard-question"></i> AskFlipt Quiz
                </div>
                <div class="askflipt-quiz-q">${q}</div>
                <div class="askflipt-quiz-opts">
                    ${optsHtml}
                </div>
                <div class="askflipt-quiz-fb correct-msg">${fbCorrect}</div>
                <div class="askflipt-quiz-fb incorrect-msg">${fbIncorrect}</div>
            `;

            const optNodes = this.querySelectorAll('.askflipt-quiz-opt');
            const fbCMsg = this.querySelector('.correct-msg');
            const fbIMsg = this.querySelector('.incorrect-msg');

            optNodes.forEach(node => {
                node.addEventListener('click', () => {
                    // Disable further clicks
                    optNodes.forEach(n => (n as HTMLElement).style.pointerEvents = 'none');
                    
                    const idx = parseInt(node.getAttribute('data-idx') || '0', 10);
                    if (idx === correctIdx) {
                        node.classList.add('correct');
                        if (fbCMsg) fbCMsg.classList.add('show');
                    } else {
                        node.classList.add('incorrect');
                        optNodes[correctIdx].classList.add('correct');
                        if (fbIMsg) fbIMsg.classList.add('show');
                    }
                });
            });
        }
    }

    customElements.define('askflipt-flashcard', AskFliptFlashcard);
    customElements.define('askflipt-quiz', AskFliptQuiz);
    customElements.define('askflipt-deck', AskFliptDeck);
}
